import styled from 'styled-components';

export const SportWrapper = styled.div`
  border-bottom: 1px solid rgb(233,213,214);
`;
